import { render, staticRenderFns } from "./person-ranking.vue?vue&type=template&id=0940a0d9&scoped=true&"
import script from "./person-ranking.vue?vue&type=script&lang=js&"
export * from "./person-ranking.vue?vue&type=script&lang=js&"
import style0 from "./person-ranking.vue?vue&type=style&index=0&id=0940a0d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0940a0d9",
  null
  
)

export default component.exports